import { Injectable } from "@angular/core";
import { LogService } from "./log.service";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class ObjectURLService extends BaseService {
  private objectUrls: { [key: string]: string } = {};

  constructor(logService: LogService) {
    super(logService, "ObjectURLService");
  }

  public create(name: string, blob: Blob) {
    const url = URL.createObjectURL(blob);
    this.objectUrls[name] = url;
    return url;
  }

  public remove(key: string) {
    const { [key]: toRemove, ...rest } = this.objectUrls;
    this.objectUrls = rest;
    return URL.revokeObjectURL(toRemove);
  }

  public removeMultiple(keys: string[]) {
    return keys.forEach((key: string) => {
      return this.remove(key);
    });
  }

  public exists(key: string) {
    return !!this.objectUrls[key];
  }

  public get(key: string) {
    return this.objectUrls[key];
  }

  public clear() {
    const urls = { ...this.objectUrls };
    this.objectUrls = {};
    return Object.values(urls).forEach((url: string) => {
      return URL.revokeObjectURL(url);
    });
  }
}
